import { usePostHog } from '@/contexts/PostHogProvider';

export const useAnalytics = () => {
  const posthog = usePostHog();

  const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    posthog.capture(eventName, properties);
  };

  const trackListingView = (listingId: string, listingTitle: string) => {
    trackEvent('listing_viewed', {
      listing_id: listingId,
      listing_title: listingTitle,
    });
  };

  const trackListingSwipe = (listingId: string, direction: 'left' | 'right') => {
    trackEvent('listing_swiped', {
      listing_id: listingId,
      direction,
      action: direction === 'right' ? 'liked' : 'passed',
    });
  };

  const trackFavoriteAdded = (listingId: string) => {
    trackEvent('favorite_added', {
      listing_id: listingId,
    });
  };

  const trackFavoriteRemoved = (listingId: string) => {
    trackEvent('favorite_removed', {
      listing_id: listingId,
    });
  };

  const trackLeadSubmitted = (listingId: string, leadType: string) => {
    trackEvent('lead_submitted', {
      listing_id: listingId,
      lead_type: leadType,
    });
  };

  const trackNDASign = (listingId: string) => {
    trackEvent('nda_signed', {
      listing_id: listingId,
    });
  };

  const trackSearch = (query: string, resultsCount: number) => {
    trackEvent('search_performed', {
      query,
      results_count: resultsCount,
    });
  };

  return {
    trackEvent,
    trackListingView,
    trackListingSwipe,
    trackFavoriteAdded,
    trackFavoriteRemoved,
    trackLeadSubmitted,
    trackNDASign,
    trackSearch,
  };
};
